/**
 * TODO:
 */
export type Config = Required<Config.Options>
export namespace Config {
  export const DEFAULT: Readonly<Config> = {
    maxEntities: 1000,
  }

  export function from({
    maxEntities = DEFAULT.maxEntities,
  }: Options = {}): Config {
    return {
      maxEntities,
    }
  }

  /**
   *
   * {@link Config} with all `undefined` properties filled in using default
   * values
   */
  export interface Options {
    /**
     * Maximum number of entities that can be stored in the cache
     *
     * @default 1000
     */
    maxEntities?: number
  }
}
